(function() {
  define('commons/circulationCharts',["jquery", "commons/chartServices"], function($, chartServices) {
    var executeDigital, executePrintHistorical, executePrintSubscription;
    executeDigital = function() {
      var populateReachData;
      populateReachData = function(dataPoints, tickInterval, min) {
        var chartSettings, d, dataValue, date, highestValue, i, item, j, k, len, len1, mediaName, weekCategories, weekLabel, weekLabels;
        mediaName = dataPoints[0].mediaName;
        highestValue = Math.max.apply(null, _.map(dataPoints, "value"));

        /*  
        Prepare array containing year, week, label
        Function getWeekChartCategories() returns an array containing data categories and labels for the x-axis
        This must be done to handle missing data in the datapoints properly
         */
        weekLabels = [];
        for (j = 0, len = dataPoints.length; j < len; j++) {
          d = dataPoints[j];
          weekLabel = {};
          date = new Date(d.period);
          weekLabel.year = date.getFullYear();
          weekLabel.week = d.week;
          weekLabel.label = d.weekLabel;
          weekLabels.push(weekLabel);
        }
        weekCategories = chartServices.getWeekChartCategories(weekLabels);
        chartSettings = {
          xAxis: {
            categories: [],
            type: "datetime",
            tickInterval: tickInterval,
            min: min,
            startOnTick: true,
            tickmarkPlacement: "on",
            labels: {
              formatter: function() {
                var week;
                week = weekCategories.find((function(_this) {
                  return function(x) {
                    return x.index === _this.value;
                  };
                })(this));
                if (week != null) {
                  return week.label;
                }
              }
            }
          },
          yAxis: {
            title: "",
            text: "",
            tickAmount: 3,
            max: highestValue,
            softMax: highestValue
          }
        };
        item = {
          chartSettings: chartSettings,
          series: [
            {
              name: mediaName,
              data: []
            }
          ]
        };
        for (i = k = 0, len1 = dataPoints.length; k < len1; i = ++k) {
          d = dataPoints[i];
          dataValue = {
            x: weekCategories[i].index,
            y: d.value,
            source: d.source,
            mediaName: d.mediaName
          };
          item.series[0].data.push(dataValue);
          i++;
        }
        return item;
      };
      if ($("#ReachDataUri").length > 0) {
        $.ajax({
          url: $("#ReachDataUri").val(),
          dataType: "jsonp"
        }).done((function(_this) {
          return function(resp) {
            var data;
            if (!((resp != null) && resp.trafficDataPoints.length)) {
              return;
            }
            $("#traffic_reach_chart").removeClass("hide");
            data = populateReachData(resp.trafficDataPoints, 5, 0);
            data.chartSettings.tooltip = {
              shared: true,
              useHTML: true,
              formatter: function() {
                return "<table> <tr> <td> " + this.points[0].point.mediaName + " </td> </tr> <tr> <td> <h4><strong>Unika " + this.points[0].point.y + "</strong></h4> </td> </tr> <tr> <td> " + this.points[0].point.source + " </td> </tr> </table>";
              }
            };
            return chartServices.renderSplineChart("uniques-chart", data.series, data.chartSettings);
          };
        })(this));
      }
      if ($("#VisitsDataUri").length > 0) {
        $.ajax({
          url: $("#VisitsDataUri").val(),
          dataType: "jsonp"
        }).done((function(_this) {
          return function(resp) {
            var data;
            if (!((resp != null) && resp.dataPoints.length)) {
              return;
            }
            $("#traffic_visits_chart").removeClass("hide");
            $("#infogr_visits_chart").removeClass("hide");
            data = populateReachData(resp.dataPoints, 5, 0);
            data.chartSettings.tooltip = {
              shared: true,
              useHTML: true,
              formatter: function() {
                return "<table> <tr> <td> " + this.points[0].point.mediaName + " </td> </tr> <tr> <td> <h4><strong>Bes&ouml;k " + this.points[0].point.y + "</strong></h4> </td> </tr> <tr> <td> " + this.points[0].point.source + " </td> </tr> </table>";
              }
            };
            return chartServices.renderSplineChart("visits-chart", data.series, data.chartSettings);
          };
        })(this));
      }
      if ($("#PageViewsDataUri").length > 0) {
        return $.ajax({
          url: $("#PageViewsDataUri").val(),
          dataType: "jsonp"
        }).done((function(_this) {
          return function(resp) {
            var data;
            if (!((resp != null) && resp.dataPoints.length)) {
              return;
            }
            $("#traffic_pageviews_chart").removeClass("hide");
            $("#infogr_pageviews_chart").removeClass("hide");
            data = populateReachData(resp.dataPoints, 5, 0);
            data.chartSettings.tooltip = {
              shared: true,
              useHTML: true,
              formatter: function() {
                return "<table> <tr> <td> " + this.points[0].point.mediaName + " </td> </tr> <tr> <td> <h4><strong>Sidvisningar " + this.points[0].point.y + "</strong></h4> </td> </tr> <tr> <td> " + this.points[0].point.source + " </td> </tr> </table>";
              }
            };
            return chartServices.renderSplineChart("pageviews-chart", data.series, data.chartSettings);
          };
        })(this));
      }
    };
    executePrintHistorical = function() {
      var populateCirculationHistoricalData;
      populateCirculationHistoricalData = function(x) {
        var actualMinYear, etidning, etidningValue, firstSeriesLabel, foundYear, isTsDist, j, k, l, len, len1, m, maxYear, minYear, plus, plusValue, results, results1, series, upplaga, upplagaValue, value, year, years;
        isTsDist = $("#IsTsDist").val();
        firstSeriesLabel = "Varav printupplaga";
        if (isTsDist) {
          firstSeriesLabel = "Varav printdistribution";
        }
        series = [
          {
            name: "Varav digital upplaga",
            data: [],
            color: "#ec068d"
          }, {
            name: "Varav digitala plusabonnemang",
            data: [],
            color: "#f7a35c"
          }, {
            name: firstSeriesLabel,
            data: [],
            color: "#7cb5ec"
          }
        ];
        maxYear = Math.max.apply(Math, x.dataPoints.map(function(y) {
          return y.year;
        }));
        minYear = Math.min.apply(Math, x.dataPoints.map(function(y) {
          return y.year;
        }));
        actualMinYear = maxYear - 4;
        years = (function() {
          results = [];
          for (var j = actualMinYear; actualMinYear <= maxYear ? j <= maxYear : j >= maxYear; actualMinYear <= maxYear ? j++ : j--){ results.push(j); }
          return results;
        }).apply(this);
        for (k = 0, len = years.length; k < len; k++) {
          year = years[k];
          foundYear = x.dataPoints.find(function(y) {
            return y.year === year;
          });
          if (!foundYear) {
            actualMinYear--;
          }
        }
        if (minYear > actualMinYear) {
          actualMinYear = minYear;
        }
        years = (function() {
          results1 = [];
          for (var l = actualMinYear; actualMinYear <= maxYear ? l <= maxYear : l >= maxYear; actualMinYear <= maxYear ? l++ : l--){ results1.push(l); }
          return results1;
        }).apply(this);
        for (m = 0, len1 = years.length; m < len1; m++) {
          year = years[m];
          upplaga = x.dataPoints.find(function(y) {
            return y.year === year && y.type === "-";
          });
          plus = x.dataPoints.find(function(y) {
            return y.year === year && y.type === "P";
          });
          etidning = x.dataPoints.find(function(y) {
            return y.year === year && y.type === "D";
          });
          upplagaValue = upplaga != null ? upplaga.value : null;
          plusValue = plus != null ? plus.value : null;
          etidningValue = etidning != null ? etidning.value : null;
          if ((upplagaValue != null) && (plusValue != null)) {
            upplagaValue = upplagaValue - plusValue;
          }
          if ((upplagaValue != null) && (etidningValue != null)) {
            upplagaValue = upplagaValue - etidningValue;
          }
          if (upplaga) {
            value = {
              name: year,
              y: upplagaValue
            };
            series[2].data.push(value);
            value = {
              name: year,
              y: plusValue
            };
            series[1].data.push(value);
            value = {
              name: year,
              y: etidningValue
            };
            series[0].data.push(value);
          }
        }
        return series;
      };
      return $.ajax({
        url: $("#CirculationColumnChart").val(),
        dataType: "jsonp"
      }).done((function(_this) {
        return function(res) {
          var chartSettings, data;
          if (!((res != null) && res.dataPoints.length)) {
            return;
          }
          $("#circulation_historical_chart").removeClass("hide");
          $("#infogr_circulation_historical_chart").removeClass("hide");
          data = populateCirculationHistoricalData(res);
          chartSettings = {
            yAxisType: "{y}",
            yAxisTickAmount: 5,
            useLabelsRotation: true,
            yAxisMaxPadding: 0.1
          };
          return chartServices.renderStackedColumnChart("print-circulation-barchart", data, chartSettings);
        };
      })(this));
    };
    executePrintSubscription = function() {
      var populateCirculationPieChartData;
      populateCirculationPieChartData = function(x) {
        var d, data, j, len, ref, series, sum, value;
        sum = x.dataPoints.reduce((function(total, y) {
          return total + y.value;
        }), 0);
        data = [];
        series = {
          data: []
        };
        ref = x.dataPoints;
        for (j = 0, len = ref.length; j < len; j++) {
          d = ref[j];
          value = {
            name: d.type,
            y: (d.value / sum) * 100
          };
          series.data.push(value);
        }
        data.push(series);
        return data;
      };
      return $.ajax({
        url: $("#CirculationPieChart").val(),
        dataType: "jsonp"
      }).done((function(_this) {
        return function(res) {
          var chartSettings, data;
          if (!((res != null) && res.dataPoints.length)) {
            return;
          }
          data = populateCirculationPieChartData(res);
          chartSettings = {
            labelsFormat: "{point.y:.1f}%"
          };
          $("#abonnemang").removeClass("hide");
          return chartServices.renderPieChart("print-circulation-piechart", data, chartSettings);
        };
      })(this));
    };
    return {
      executeDigital: executeDigital,
      executePrintHistorical: executePrintHistorical,
      executePrintSubscription: executePrintSubscription
    };
  });

}).call(this);

//# sourceMappingURL=circulationCharts.js.map
;
